import { render, staticRenderFns } from "./MarketplaceProductsCreation.vue?vue&type=template&id=3e06b1b8&scoped=true"
import script from "./MarketplaceProductsCreation.vue?vue&type=script&lang=js"
export * from "./MarketplaceProductsCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e06b1b8",
  null
  
)

export default component.exports